import React, { useMemo } from 'react'
import { Label } from 'semantic-ui-react'

export const SectionDateHeader = ({ startDate, matches: matches_date, showMissingMatches, handleShowMissingMatches }) => {

  const counts = useMemo(() => {
    const allMatches = _.flatMap(matches_date ?? {}, matches => matches);
    // const _matches = _.values(matches_date ?? {});
    const total = _.size(allMatches);
    const completed = _.filter(allMatches, (m) => !!m?.results).length;
    const matchDay = _.filter(allMatches, (m) => !!m?._results_matchDay).length;
    const missing = _.filter(allMatches, (m) => !!m?._status?.isMissing).length;
    return { total, completed, missing, matchDay };
  }, [matches_date]);

  return <div className="match-date-header header-flex">
    <div>{startDate}</div>
    <div className='hi-right'>
      {counts.matchDay > 0 && <Label size='tiny' className={'rmd'} title='Match Day'>{counts.matchDay}</Label>}
      {counts.missing > 0 && <Label size='tiny' className={showMissingMatches ? 'miss-o' : 'miss'} title='Missing' onClick={() => { handleShowMissingMatches() }}>{counts.missing}</Label>}
      <Label size='tiny' color='black' title={'Total'}>{counts.total}</Label>
    </div>
  </div>
}
